import { makeVar, useReactiveVar } from "@apollo/client";

import { AutocompleteOptionType } from "../models/autocomplete";

export const selectedModelVariable = makeVar<AutocompleteOptionType | null>(
  null
);

export const useSelectedModel = () => useReactiveVar(selectedModelVariable);
